import { v4 as uuidv4 } from 'uuid';
import useLocalState from "./useLocalState";

export const useDemoPortfolioNavUpdates = (accountId) => {
    const [navUpdates, setNavUpdates] = useLocalState('portfolioNavUpdates', []);

    const addPortfolioNav = async ({amountInCents, loggedAt, isInvestment}) => {
        setNavUpdates([...navUpdates, {
            id: uuidv4(),
            userId: accountId,
            amountInCents: amountInCents,
            loggedAt: new Date(loggedAt),
            isInvestment: isInvestment || false
        }])
    }

    const removePortfolioNav = async (id) => {
        setNavUpdates(navUpdates.filter(navUpdate => navUpdate.id !== id))
    }

    return { navUpdates, addPortfolioNav, removePortfolioNav };
};

